import React, { createContext, useContext, useState, useEffect } from 'react';

const CartContext = createContext();

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      const saved = localStorage.getItem('offerte_cart');
      return saved ? JSON.parse(saved) : [];
    } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem('offerte_cart', JSON.stringify(items));
  }, [items]);

  const addItem = (product, variant, orderType = 'pallet', quantity = 1) => {
    const key = `${product.id}_${variant || 'default'}`;
    setItems(prev => {
      const existing = prev.find(i => i.key === key);
      if (existing) {
        return prev.map(i => i.key === key ? { ...i, quantity: i.quantity + quantity } : i);
      }
      return [...prev, {
        key,
        productId: product.id,
        productName: product.name_nl,
        productNameEn: product.name_en,
        productNameFr: product.name_fr,
        productNameDe: product.name_de,
        variant: variant || '',
        imageUrl: product.image_url || '',
        orderType,
        quantity,
      }];
    });
  };

  const updateItem = (key, updates) => {
    setItems(prev => prev.map(i => i.key === key ? { ...i, ...updates } : i));
  };

  const removeItem = (key) => {
    setItems(prev => prev.filter(i => i.key !== key));
  };

  const clearCart = () => setItems([]);

  const itemCount = items.reduce((sum, i) => sum + i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, addItem, updateItem, removeItem, clearCart, itemCount }}>
      {children}
    </CartContext.Provider>
  );
};
